<script>
    import { translations, current_lang } from '../stores.js';
    import {replace} from 'svelte-spa-router'

    function return_to_main_menu(){
        replace("/");
    }
</script>
<div class="content-container">
    <h2>{$translations["ERROR"][$current_lang]}</h2>
    <p>{$translations["CONTENT_NOT_FOUND"][$current_lang]}.</p>
    <div class="button" on:click={return_to_main_menu}>{$translations["RETURN_TO_MAIN_MENU"][$current_lang]}</div>
</div>
<style>
    .button{
        background-color: var(--theme-color-1);
        color: #fff;
        font-family: 'futura-pt', Arial;
        color: #fff;
        font-weight: 700;
        text-decoration: none;
        text-transform: none;
        font-size: 1.4rem;
        border-radius: 96px;
        padding: 5px 30px;
        display: inline-block;
        margin-top: 15px;
    }
</style>